import { Box, Text } from '@fairfashion/design-system'

import * as Styles from './item-data.styles'
import { ItemDataProps } from './item-data.types'

export const ItemData = ({ item }: ItemDataProps) => {
  return (
    <Styles.Container width="100%" flex={1} flexWrap="wrap">
      <Box direction="column">
        <Text size="small" color="grey_3">
          Descrição
        </Text>
        <Text size="small" fontWeight={500}>
          {item?.description ?? ''}
        </Text>
      </Box>
      <Box direction="column">
        <Text size="small" color="grey_3">
          Código SKU
        </Text>
        <Text size="small" fontWeight={500}>
          {item?.code}
        </Text>
      </Box>

      <Box direction="column">
        <Text size="small" color="grey_3">
          Quantidade
        </Text>
        <Text size="small" fontWeight={500}>
          {item?.quantity}
        </Text>
      </Box>
      <Box direction="column">
        <Text size="small" color="grey_3">
          Unidade
        </Text>
        <Text size="small" fontWeight={500}>
          {item?.taxUnit}
        </Text>
      </Box>
    </Styles.Container>
  )
}
